const Score = 'score'
const Title = 'title'
const Paddle = 'paddle'
const Bounds = 'bounds'
export {
    Score,
    Title,
    Paddle,
    Bounds
}